var nav = function () {
    var navList = document.querySelectorAll('.nav-item');
    var navMainPageBtn = document.querySelector('#nav-main-page');
    var navDictionaryBtn = document.querySelector('#nav-dictionary');
    var navSprintGameBtn = document.querySelector('#nav-sprint-game');
    var navAudioGameBtn = document.querySelector('#nav-audio-game');
    var navStatisticsBtn = document.querySelector('#nav-statistics');
    var navMainPageBtnA = document.querySelector('#nav-main-page-adaptive');
    var navDictionaryBtnA = document.querySelector('#nav-dictionary-adaptive');
    var navSprintGameBtnA = document.querySelector('#nav-sprint-game-adaptive');
    var navAudioGameBtnA = document.querySelector('#nav-audio-game-adaptive');
    var navStatisticsBtnA = document.querySelector('#nav-statistics-adaptive');
    var startPage = document.querySelector('#start-page');
    var dictionaryPage = document.querySelector('#dictionary-page');
    var sprintGamePage = document.querySelector('#sprint-game-page');
    var audioGamePage = document.querySelector('#audio-game-page');
    var statisticsPage = document.querySelector('#statistics-page');
    var footer = document.querySelector('#footer');
    var navMainPageBtnF = document.querySelector('#nav-main-page-footer');
    var navDictionaryBtnF = document.querySelector('#nav-dictionary-footer');
    var navSprintGameBtnF = document.querySelector('#nav-sprint-game-footer');
    var navAudioGameBtnF = document.querySelector('#nav-audio-game-footer');
    var navStatisticsBtnF = document.querySelector('#nav-statistics-footer');
    var pageList = [startPage, dictionaryPage, sprintGamePage, audioGamePage, statisticsPage];
    function switchActiveTab(currentTabsNum) {
        navList.forEach(function (value) { return value.classList.remove('nav-item-active'); });
        navList[currentTabsNum].classList.add('nav-item-active');
    }
    function hideUnnecessaryBlocks(currentTabsNum) {
        pageList.forEach(function (value) { return value.classList.add('visually-hidden'); });
        pageList[currentTabsNum].classList.remove('visually-hidden');
        if (currentTabsNum == 0) {
            footer.classList.remove('visually-hidden');
        }
        else {
            footer.classList.add('visually-hidden');
        }
    }
    function closeAdaptiveMenu() {
        document.querySelector('.menu__button').classList.remove('open');
        document.querySelector('.menu-adaptive').classList.remove('open');
    }
    navMainPageBtn.addEventListener('click', function () {
        switchActiveTab(0);
        hideUnnecessaryBlocks(0);
    });
    navDictionaryBtn.addEventListener('click', function () {
        switchActiveTab(1);
        hideUnnecessaryBlocks(1);
    });
    navSprintGameBtn.addEventListener('click', function () {
        switchActiveTab(2);
        hideUnnecessaryBlocks(2);
    });
    navAudioGameBtn.addEventListener('click', function () {
        switchActiveTab(3);
        hideUnnecessaryBlocks(3);
    });
    navStatisticsBtn.addEventListener('click', function () {
        switchActiveTab(4);
        hideUnnecessaryBlocks(4);
    });
    navMainPageBtnA.addEventListener('click', function () {
        closeAdaptiveMenu();
        hideUnnecessaryBlocks(0);
    });
    navDictionaryBtnA.addEventListener('click', function () {
        closeAdaptiveMenu();
        hideUnnecessaryBlocks(1);
    });
    navSprintGameBtnA.addEventListener('click', function () {
        closeAdaptiveMenu();
        hideUnnecessaryBlocks(2);
    });
    navAudioGameBtnA.addEventListener('click', function () {
        closeAdaptiveMenu();
        hideUnnecessaryBlocks(3);
    });
    navStatisticsBtnA.addEventListener('click', function () {
        closeAdaptiveMenu();
        hideUnnecessaryBlocks(4);
    });
    navMainPageBtnF.addEventListener('click', function () {
        switchActiveTab(0);
        hideUnnecessaryBlocks(0);
    });
    navDictionaryBtnF.addEventListener('click', function () {
        switchActiveTab(1);
        hideUnnecessaryBlocks(1);
    });
    navSprintGameBtnF.addEventListener('click', function () {
        switchActiveTab(2);
        hideUnnecessaryBlocks(2);
    });
    navAudioGameBtnF.addEventListener('click', function () {
        switchActiveTab(3);
        hideUnnecessaryBlocks(3);
    });
    navStatisticsBtnF.addEventListener('click', function () {
        switchActiveTab(4);
        hideUnnecessaryBlocks(4);
    });
    /*для перехода в аудиоигру из учебника*/
    document.querySelector('#dictionary-button-audio').addEventListener('click', function () {
        closeAdaptiveMenu();
        switchActiveTab(3);
        hideUnnecessaryBlocks(3);
    });
    //*для перехода в игру спринт
    document.querySelector('#dictionary-button-sprint').addEventListener('click', function () {
        closeAdaptiveMenu();
        switchActiveTab(2);
        hideUnnecessaryBlocks(2);
        var lvlBtns = document.querySelector('.choose-level');
        var startBtn = document.querySelector('#lvl-btn');
        if (!lvlBtns.classList.contains('visually-hidden')) {
            lvlBtns.classList.toggle('visually-hidden');
        }
        if (startBtn.classList.contains('visually-hidden')) {
            startBtn.classList.toggle('visually-hidden');
        }
    });
};
export { nav };
